import React from 'react';
import { Oval } from 'react-loader-spinner';

export default function OvalLoader({ height = '30', width = '30', radius = '12.5' }) {
    return (
        <Oval
            height={height}
            width={width}
            color="#0722d5"
            ariaLabel="grid-loading"
            secondaryColor="#0d6efd"
            strokeWidth={2}
            strokeWidthSecondary={2}
            radius={radius}
            wrapperStyle={{
                display: 'flex',
                justifyContent: 'center',
            }}
            wrapperClass=""
            visible
        />
    );
}
